"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableBlockLanguages = exports.BlockLanguageEnum = void 0;
const shared_1 = require("../shared");
var BlockLanguageEnum;
(function (BlockLanguageEnum) {
    BlockLanguageEnum["en"] = "en";
    BlockLanguageEnum["de"] = "de";
    BlockLanguageEnum["any"] = "any";
})(BlockLanguageEnum || (exports.BlockLanguageEnum = BlockLanguageEnum = {}));
const availableBlockLanguages = [BlockLanguageEnum.en, BlockLanguageEnum.de];
const availableInternalBlockLanguages = [BlockLanguageEnum.en];
const getAvailableBlockLanguages = (visibility) => {
    return visibility === shared_1.Visibility.Internal ? availableInternalBlockLanguages : availableBlockLanguages;
};
exports.getAvailableBlockLanguages = getAvailableBlockLanguages;
//# sourceMappingURL=blockLanguage.js.map